import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { isDateInputAvailable } from '../../../resources/utilities'
import DatePicker from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'
import './style.css'

const dateFormat = {
  standartData: 'YYYY-MM-DD'
}

class DateInput extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      [props.name]: props.value
    }
    this.handleChangeInput = this.handleChangeInput.bind(this)
  }

  handleChangeInput (e) {
    const name = e.target.name
    const value = e.target.value
    this.setState({
      [name]: value
    })
    this.props.handleChange(name, value)
  }

  handleDateChange (e) {
    const name = this.props.name
    const value = moment(e).format(dateFormat.standartData)
    this.setState({
      [name]: value
    })
    this.props.handleChange(name, value)
  }

  getMinimumDate (date) {
    if (date) {
      const obj = moment(date)
      return obj.format(dateFormat.standartData)
    } else {
      return null
    }
  }

  getMaximumDate (date) {
    if (date) {
      const obj = moment(date)
      return obj.format(dateFormat.standartData)
    } else {
      return null
    }
  }

  render () {
    if (isDateInputAvailable()) {
      return <input
        min={this.getMinimumDate(this.props.minDate)}
        max={this.getMaximumDate(this.props.maxDate)}
        type='date'
        pattern='[0-9]{4}-[0-9]{2}-[0-9]{2}'
        readOnly={this.props.readOnly}
        required={this.props.required}
        name={this.props.name}
        value={this.state[this.props.name] || ''}
        placeholder={this.props.placeholder}
        onChange={(e) => this.handleChangeInput(e)}
        className='form-control' />
    } else {
      return <DatePicker
        className='form-control'
        name={this.props.name}
        readOnly={this.props.readOnly}
        required={this.props.required}
        selected={moment(this.state[this.props.name]) || ''}
        onChange={(e) => this.handleDateChange(e)} />
    }
  }
}

DateInput.propTypes = {
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  minDate: PropTypes.string,
  maxDate: PropTypes.string
}

export { DateInput }



// WEBPACK FOOTER //
// ./src/components/common/DateInput/DateInput.js